export const NON_STANDARD_TOOLS_REQUESTED_LABEL_PREFIX =
  '*** Non-standard tools requested: ';

export const NON_STANDARD_TOOLS_REQUESTED_LABEL_SUFFIX = '***';
